<template>
	<div
		v-show="pending"
		v-bind="$attrs"
		class="flex w-full flex-col items-start xl:ml-xl"
	>
		<div class="invisible h-12">...</div>
		<!--
        <div class="flex flex-row items-start justify-start">
            <v-placeholder class="h-[24px] w-[147px] rounded bg-gray-50 via-gray-100" />
        </div>

        <v-placeholder class="mt-2 h-4 w-60 rounded bg-gray-50 via-gray-100" />
        -->
	</div>

	<!-- Hide if pending or if would render no actual content -->
	<!-- Avoid rendering time-sensitive content before mount to prevent hydration mismatches. -->
	<div
		v-show="
			!pending &&
			((properties.promotionInfo.showEndingTimer &&
				(!properties.promotionInfo.isTimedVisibility || isWithin48Hours)) ||
				(promotionInfo.showCountdownTextContent && activeToWithContent) ||
				promotionInfo.campaignModalContent)
		"
		v-bind="$attrs"
	>
		<template v-if="promotionInfo.activeTo">
			<v-page-product-countdown-timer
				v-show="
					properties.promotionInfo.showEndingTimer &&
					(!properties.promotionInfo.isTimedVisibility || isWithin48Hours)
				"
				:active-to="promotionInfo.activeTo"
			/>
		</template>

		<p>
			<span
				v-if="promotionInfo.showCountdownTextContent"
				class="mb-xs text-sm font-bold text-wrap"
			>
				{{ activeToWithContent }}
			</span>

			<!-- Make sure there's a space between the activity text and the button -->
			{{ " " }}

			<button
				v-if="promotionInfo.isCampaignModalEnabled"
				type="button"
				@click="isDiscountsOpen = !isDiscountsOpen"
			>
				<span class="text-sm font-bold text-wrap underline">
					{{ promotionInfo.campaignModalContent }}
				</span>
			</button>

			<span v-else class="text-sm font-bold text-wrap">
				{{ promotionInfo.campaignModalContent }}
			</span>
		</p>
	</div>

	<client-only>
		<lazy-v-discounts-modal
			:is-open="isDiscountsOpen"
			:options="{isModal: true}"
			@close="isDiscountsOpen = false"
		/>
	</client-only>
</template>

<script setup lang="ts">
interface PromotionInfo {
	activeTo?: Date;
	hidePriceHistory: boolean;
	showEndingTimer: boolean;
	showCountdownTextContent: boolean;
	promotionTimerContent: string;
	isTimedVisibility: boolean;
	isCampaignModalEnabled: boolean;
	campaignModalContent: string;
}
const properties = defineProps<{
	pending: boolean;
	promotionInfo: PromotionInfo;
}>();

const isDiscountsOpen = ref(false);

const regex = /#date/i;

const activeToWithContent = computed<string>(() =>
	properties.promotionInfo.promotionTimerContent.replace(
		regex,
		() =>
			properties.promotionInfo.activeTo?.toLocaleDateString(["fi-FI"]) || "",
	),
);

const isWithin48Hours = computed(() => {
	const now = new Date();
	const timeDifference =
		(properties.promotionInfo.activeTo ?? new Date()).getTime() - now.getTime();
	const hoursDifference = timeDifference / (1000 * 60 * 60);

	return hoursDifference > 0 && hoursDifference <= 48;
});
</script>
